exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#save-btn.v-btn--disabled[data-v-6679b328] {\n    background-color: #E0E0E0!important;\n    color: #555!important;\n}\n", ""]);

// exports
